import { SpaceBetween } from "@cloudscape-design/components-themed";
import Table from "../components/bank-accounts/Table";
import SearchBar from "../components/bank-accounts/SearchBar";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useAuthenticationHook } from "../app/useAuthenticationHook";
import { USER_TYPE, PERMISSIONS } from "../configs/constants";
import { useState } from "react";

const BankAccounts = () => {
  // 権限制御
  const authenticated = useAuthenticationHook(PERMISSIONS.APPLY_COMPANY_READ);

  // ユーザ種別確認
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  const [isSkipSearch, setIsSkipSearch] = useState(true);

  return (
    <SpaceBetween size="l">
      {authenticated && (
        <>
          <SearchBar
            isDocomoUser={isDocomoUser}
            setIsSkipSearch={setIsSkipSearch}
          />
          <Table isSkipSearch={isSkipSearch} />
        </>
      )}
    </SpaceBetween>
  );
};

export default BankAccounts;
